import { reactive } from 'vue';

export const onboardStore = reactive({
  currentStep: 1,
})
